export default "__VITE_ASSET__DMzdovFE__"